import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";
import _defineProperty from "D:\\projects\\suseval\\node_modules\\@babel\\runtime-corejs2/helpers/defineProperty";
import _regeneratorRuntime from "D:\\projects\\suseval\\node_modules\\@babel\\runtime-corejs2/regenerator";
import "core-js/modules/es6.regexp.replace";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:\\projects\\suseval\\node_modules\\@babel\\runtime-corejs2/helpers/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import * as Sentry from '@sentry/vue';
import { Replay } from '@sentry/replay';
import { BrowserTracing } from '@sentry/tracing';
import html2canvas from 'html2canvas';
/*
async function uploadFile (file) {
    console.log('-----------------uploadFile---------------------')
    var url = `https://api.cloudinary.com/v1_1/de-ontwikkelfabriek/upload`
    var xhr = new XMLHttpRequest()
    var fd = new FormData()
    xhr.open('POST', url, true)
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest')

    // Reset the upload progress bar
    // document.getElementById('progress').style.width = 0

    // Update progress (can be used to show progress indicator)
    // xhr.upload.addEventListener('progress', function (e) {
    //     var progress = Math.round((e.loaded * 100.0) / e.total)
    //     document.getElementById('progress').style.width = progress + '%'
    //
    //     console.log(`fileuploadprogress data.loaded: ${e.loaded},  data.total: ${e.total}`)
    // })

    xhr.onreadystatechange = function (e) {
        console.log('onreadystatechange', e)
        if (xhr.readyState === 4 && xhr.status === 200) {
            // File uploaded successfully
            var response = JSON.parse(xhr.responseText)
            // https://res.cloudinary.com/cloudName/image/upload/v1483481128/public_id.jpg
            var url = response.secure_url
            myurl = response.secure_url
            console.log('--------URL---------', url)
            return url
            // Create a thumbnail of the uploaded image, with 150px width
            // var tokens = url.split('/')
            // tokens.splice(-2, 0, 'w_150,c_scale')
            // var img = new Image() // HTML5 Constructor
            // img.src = tokens.join('/')
            // img.alt = response.public_id
            // document.getElementById('gallery').appendChild(img)
        }
    }

    fd.append('upload_preset', 'suseval_error_screenshots')
    fd.append('tags', 'browser_upload') // Optional - add tag for image admin in Cloudinary
    fd.append('file', file)
    xhr.send(fd)
}
*/

function fileUpload(_x) {
  return _fileUpload.apply(this, arguments);
}

function _fileUpload() {
  _fileUpload = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee4(file) {
    var url, xhr, fd;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            url = "https://api.cloudinary.com/v1_1/de-ontwikkelfabriek/upload";
            xhr = new XMLHttpRequest();
            fd = new FormData();
            xhr.open('POST', url, true);
            xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
            return _context4.abrupt("return", new Promise(function (resolve, reject) {
              xhr.onreadystatechange = function (e) {
                // console.log('onreadystatechange', e)
                if (xhr.readyState === 4 && xhr.status === 200) {
                  // File uploaded successfully
                  var response = JSON.parse(xhr.responseText);
                  var url = response.secure_url; // console.log('--------URL---------', url)

                  resolve(url); // Create a thumbnail of the uploaded image, with 150px width
                  // var tokens = url.split('/')
                  // tokens.splice(-2, 0, 'w_150,c_scale')
                  // var img = new Image() // HTML5 Constructor
                  // img.src = tokens.join('/')
                  // img.alt = response.public_id
                  // document.getElementById('gallery').appendChild(img)
                }
              }; // xhr.addEventListener('load', event => resolve(event), false)
              // xhr.addEventListener('error', event => reject(event), false)
              // xhr.addEventListener('abort', event => reject(event), false)


              fd.append('upload_preset', 'suseval_error_screenshots');
              fd.append('tags', 'browser_upload'); // Optional - add tag for image admin in Cloudinary

              fd.append('file', file);
              xhr.send(fd); // console.log('fileeee')
              // console.log(file)
              // console.log(file)
              // if (file !== 'data:,') {
              //     console.log('GOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOO')
              //
              // } else {
              //     console.log('DUMPPPPPPPPPPPPPPPPPPPPPPPPP')
              // }
            }));

          case 6:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _fileUpload.apply(this, arguments);
}

export default
/*#__PURE__*/
(function () {
  var _ref2 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee3(_ref) {
    var Vue, router, pjson;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            Vue = _ref.Vue, router = _ref.router;

            if (!process.env.DEV) {
              pjson = require("../../package.json");
              Sentry.init({
                Vue: Vue,
                release: 'suseval@' + pjson.version,
                environment: 'test',
                logErrors: true,
                dsn: 'https://de1282bcaa5f4f138ae57ad34a55032e@o280731.ingest.sentry.io/6396080',
                integrations: [new BrowserTracing({
                  routingInstrumentation: Sentry.vueRouterInstrumentation(router),
                  tracingOrigins: ['localhost', 'app.sustainabilityevaluation.org', /^\//]
                }), new Replay({
                  // This sets the sample rate to be 10%. You may want this to be 100% while
                  // in development and sample at a lower rate in production
                  sessionSampleRate: 1.0,
                  // If the entire session is not sampled, use the below sample rate to sample
                  // sessions when an error occurs.
                  errorSampleRate: 1.0 // Mask all text content with asterisks (*). Passes text
                  // content through to `maskTextFn` before sending to server.
                  //
                  // Defaults to true, uncomment to change
                  // maskAllText: true,
                  // Block all media elements (img, svg, video, object,
                  // picture, embed, map, audio)
                  //
                  // Defaults to true, uncomment to change
                  // blockAllMedia: true,

                })],
                ignoreErrors: ['ResizeObserver loop limit exceeded'],
                // We recommend adjusting this value in production, or using tracesSampler
                // for finer control
                tracesSampleRate: 1.0
              });
              Sentry.configureScope(function (scope) {
                scope.addEventProcessor(
                /*#__PURE__*/
                function () {
                  var _ref3 = _asyncToGenerator(
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee2(event, hint) {
                    var screenshot, screenshotUrl;
                    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            _context2.next = 2;
                            return html2canvas(document.querySelector('#q-app')).then(
                            /*#__PURE__*/
                            function () {
                              var _ref4 = _asyncToGenerator(
                              /*#__PURE__*/
                              _regeneratorRuntime.mark(function _callee(canvas) {
                                return _regeneratorRuntime.wrap(function _callee$(_context) {
                                  while (1) {
                                    switch (_context.prev = _context.next) {
                                      case 0:
                                        return _context.abrupt("return", canvas.toDataURL('image/png').replace('image/png', 'image/octet-stream'));

                                      case 1:
                                      case "end":
                                        return _context.stop();
                                    }
                                  }
                                }, _callee);
                              }));

                              return function (_x5) {
                                return _ref4.apply(this, arguments);
                              };
                            }());

                          case 2:
                            screenshot = _context2.sent;
                            _context2.next = 5;
                            return fileUpload(screenshot);

                          case 5:
                            screenshotUrl = _context2.sent;
                            return _context2.abrupt("return", _objectSpread({}, event, {
                              extra: {
                                // ...event.extra,
                                // screenshot: screenshotUrl
                                screenshot: screenshotUrl
                              }
                            }));

                          case 7:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2);
                  }));

                  return function (_x3, _x4) {
                    return _ref3.apply(this, arguments);
                  };
                }());
              }); // Sentry.setTag('rrweb.active', 'yes')
            }

          case 2:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function (_x2) {
    return _ref2.apply(this, arguments);
  };
})();